import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
export function NavigationTitle(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="text-text-tertiary text-sm font-medium uppercase">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}